var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-alert',{attrs:{"type":_vm.notification.type,"border":"left","dismissible":""},on:{"input":function($event){return _vm.closeNotification(_vm.notification.id)}}},[_vm._v(" "+_vm._s(_vm.notification.message)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }